// Track the ?ref= code across pages so both email signup and Google OAuth can credit it.
const KEY = "tc_ref";
const AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export const captureRefFromUrl = () => {
  try {
    const q = new URLSearchParams(window.location.search);
    const ref = q.get("ref");
    if (ref && /^[A-Z0-9]{4,10}$/i.test(ref)) {
      localStorage.setItem(KEY, JSON.stringify({ code: ref.toUpperCase(), ts: Date.now() }));
    }
  } catch {}
};

export const getStoredRef = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw);
    if (!code || Date.now() - (ts || 0) > AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
};

export const clearStoredRef = () => {
  try { localStorage.removeItem(KEY); } catch {}
};
